import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    GeniusScoreboardWrapper,
    GeniusScoreboardIframe,
} from 'src/domains/sportsbook/webview/components/scoreboards/genius/GeniusScoreboard.style';
import { getGeniusWidgetConfig } from 'src/domains/sportsbook/webview/components/scoreboards/genius/getGeniusWidgetConfig';

interface GeniusScoreboardPropsType {
    event: EventModel;
    /** When Game Tracker is UNAVAILABLE we fall back to Multisport Scoreboard even if config kind is gameTracker */
    ignoreKindCheck?: boolean;
}

export const GeniusScoreboard = observer(
    'GeniusScoreboard',
    ({ event, ignoreKindCheck = false }: GeniusScoreboardPropsType) => {
        const common = useCommon();
        const config = ConfigComponents.get(common).config;
        const widgetConfig = getGeniusWidgetConfig(event, config);

        if (widgetConfig === null) {
            return null;
        }

        if (ignoreKindCheck === false && widgetConfig.kind !== 'scoreboard') {
            return null;
        }

        const { geniusScoreboard, fixtureId } = widgetConfig;
        const iframeUrl = `${geniusScoreboard.baseUrl}/multisportscoreboard?fixtureId=${fixtureId}&productName=${geniusScoreboard.productName}`;

        return (
            <GeniusScoreboardWrapper data-test='genius-scoreboard'>
                <GeniusScoreboardIframe
                    src={iframeUrl}
                    title={`Genius Scoreboard for Event ${fixtureId}`}
                    loading='lazy'
                    allowFullScreen
                    referrerPolicy='no-referrer-when-downgrade'
                    data-test='genius-scoreboard-iframe'
                />
            </GeniusScoreboardWrapper>
        );
    }
);
